<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-contact-person-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {}
    },
}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.name">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.POSITION') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.position">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.EMAIL') }}
            </label>
            <div class="col-md-6">
                <input type="email" class="form-control" v-model="model.email">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.PHONE') }}
            </label>
            <div class="col-md-6">
                <input type="tel" class="form-control" v-model="model.phone">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.DESCRIPTION') }}
            </label>
            <div class="col-md-6">
                <textarea class="form-control" v-model="model.description" name="description" rows="4"></textarea>
            </div>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/ContactPersonForm.vue